import React from 'react';
import AutoFlagDetailSection from '../../../sections/AdminDashboard/Moderation/AutoFlagDetail';

const AdminAutoFlagDetail = () => {
  return <AutoFlagDetailSection />;
};

export default AdminAutoFlagDetail;

